import { useEffect, useRef } from 'react';

export default function IntroScreen({ onComplete }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) return;

    video.currentTime = 0;

    video.play().catch((error) => {
      console.warn('The intro video could not autoplay:', error);
    });
  }, []);

  return (
    <div className="intro-screen">
      <video
        ref={videoRef}
        className="intro-screen__video"
        autoPlay
        muted
        playsInline
        preload="auto"
        onEnded={onComplete}
      >
        <source src="/assets/intro.mp4" type="video/mp4" />
      </video>

      <button
        type="button"
        className="intro-screen__skip"
        onClick={onComplete}
      >
        Skip Intro
      </button>
    </div>
  );
}